module.exports = __webpack_public_path__ + "static/media/kenya.9a279548.png";